import https from "./https-common";

const getAllDiscounts = (shopDomain) => {
  let shop = shopDomain.replace(".myshopify.com", "");
  shop = shop.replace("https://", "");
  return https.get(`/discounts?shop=${shop}`);
};

const DiscountFeatureService = {
  getAllDiscounts,
};

export default DiscountFeatureService;
